module.exports = __webpack_public_path__ + "static/media/SarahSwitek_13_Activities-Instructions_4.4b32f11b.mp3";